<template>
    <div class="People">
        <!-- FAMILY -->
        <div class="row record-section-row">
            <div class="col">
                <h4>Caregivers:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Caregiver'}"
                                                add-edit-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Caregiver"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true"
                                                :include-is-disabled="true"
                                                :include-language="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Children:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Child'}"
                                                add-edit-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Child"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true"
                                                :include-is-disabled="true"
                                                :include-language="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Other Family Members:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Other'}"
                                                add-edit-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="PostAdopt/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Other"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true"
                                                :include-is-disabled="true"
                                                :include-language="true" />
                </div>
            </div>
        </div>
        <!-- APSS TEAM -->
        <div class="row record-section-row">
            <div class="col">
                <h4>Case Managers:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                            team-role="Case Manager"
                                            :chart-id="RecordData.Id"
                                            :table-data="EmployeeRoleSplit.CaseManagers" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Mentors:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                            team-role="Mentor"
                                            :chart-id="RecordData.Id"
                                            :table-data="EmployeeRoleSplit.Mentors" />

                </div>
            </div>
        </div>
        <!-- MENTAL HEALTH TEAM -->
        <div class="row record-section-row">
            <div class="col">
                <h4>Mental Health Team:</h4>
                <div v-for="child in RecordData.Clients.filter(x => x.Client.ClientType == 'Child')" :key="child.Id">
                    <h4>{{child.Client.Person.FullName}}</h4>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="GlobalUpdate"
                                           add-edit-endpoint="PostAdopt/CommunityFamilyEntityContacts"
                                           :add-edit-payload="{ChartID: RecordData.Id, ClientCommunityFamilyMembershipID: child.Id}"
                                           delete-endpoint="PostAdopt/CommunityFamilyEntityContacts"
                                           :require-dob="false"
                                           contact-category="Mental Health Team"
                                           :relationship-options="ProfessionalOptions"
                                           :relationship-label="child.Client.Person.FirstName"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true"
                                           :loaded-records="Contacts.MentalHealthTeam[child.Id]" />

                </div>
            </div>
        </div>
        <!-- PROFESSIONALS -->
        
        <div class="row record-section-row">
            <div class="col">
                <h4>Professionals:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="GlobalUpdate"
                                           add-edit-endpoint="PostAdopt/CommunityFamilyEntityContacts"
                                           :add-edit-payload="{ChartID: RecordData.Id}"
                                           delete-endpoint="PostAdopt/CommunityFamilyEntityContacts"
                                           :require-dob="false"
                                           contact-category="Professionals"
                                           :relationship-options="ProfessionalOptions"
                                           relationship-label="Family"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true" 
                                           :loaded-records="Contacts.Professionals"/>
                </div>
            </div>
        </div>
        


        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    //import SingleMembershipEditor from '../../../../Core/ItemEditors/SingleMembershipEditor';
    //import MultiMembershipEditor from '../../../../Core/ItemEditors/MultiMembershipEditor';
    //import CareCommunityEditor from '../../../../Core/ItemEditors/CareCommunityEditor';
    import FamilyClientDisplayAndEdit from '../../../../Core/ItemEditors/FamilyClientDisplayAndEdit.vue';
    import ContactDisplayAndEdit from './ContactDisplayAndEdit.vue';
    import EmployeeCaseloadEditor from './EmployeeCaseloadEditor.vue';
    //import FamilyDogDisplayAndEdit from './FamilyDogDisplayAndEdit.vue';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            //SingleMembershipEditor,
            //MultiMembershipEditor,
            FamilyClientDisplayAndEdit,
            EmployeeCaseloadEditor,
            ContactDisplayAndEdit,
            //FamilyDogDisplayAndEdit,
            //CareCommunityEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            },
            EmployeeRoleSplit: function () {
                let output = {
                    CaseManagers: this.RecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Case Manager"),
                    Therapists: this.RecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Therapist"),
                    Mentors: this.RecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Mentor"),
                };
                return output;
            },
            ProfessionalOptions: function () {
                return this.$store.state.Options.ProfessionalTypes;
            },
            Contacts: function () {
                
                let output = {
                    Professionals: [],
                    MentalHealthTeam: {},
                };

                if (this.RecordData.CommunityFamilyContacts == null) {
                    return output;
                }

                this.RecordData.CommunityFamilyContacts.forEach(contact => {
                    if (contact.EntityContact.ContactCategory == "Professionals") {
                        output.Professionals.push(contact);
                    }
                    if (contact.EntityContact.ContactCategory == "Mental Health Team") {
                        if (contact.ClientCommunityFamilyMembershipID in output.MentalHealthTeam == false) {
                            output.MentalHealthTeam[contact.ClientCommunityFamilyMembershipID] = [];
                        }
                        output.MentalHealthTeam[contact.ClientCommunityFamilyMembershipID].push(contact);
                    }


                });

                return output;
            }
        }
    }
</script>

<style scoped>
</style>